// AppRoutes.js
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import SidebarLayout from './pages/EBrary/SidebarLayout';
import MyCourse from './pages/EBrary/MyCourse';
import AccessCourse from './pages/EBrary/AccessCourse';
import MyLibrary from './pages/EBrary/MyLibrary';
import EbraryCollection from './pages/EBrary/EbraryCollection';
import EJournals from './pages/EBrary/EJournals';
import Journal_Articles from './pages/EBrary/Journal_Articles';
import LibraryManagement from './pages/EBrary/LibraryManagement';
import UserManagement from './pages/EBrary/UserManagement';
import AddUserPage from './pages/EBrary/AddUserPage';
import AddBookPage from './pages/EBrary/AddBookPage';
import AddBookPage1 from './pages/EBrary/AddBookPage1';
import AddBookPage2 from './pages/EBrary/AddBookPage2';
import EditUserPage from './pages/EBrary/EditUserPage';
import EditBookPage from './pages/EBrary/EditBookPage';
import DeleteBookPage from './pages/EBrary/DeleteBookPage';
import DeleteUserPage from './pages/EBrary/DeleteUserPage';
import UsageReports from './pages/EBrary/UsageReports';
import ArticleDetails_Self from './pages/EBrary/ArticleDetails_Self';
import ArticleDetails_Book from './pages/EBrary/ArticleDetails_Book';
import ArticleDetails_Ebrary from './pages/EBrary/ArticleDetails_Ebrary';
import ELearningModulePage from './pages/EBrary/ELearningModulePage';
import JournalDetails from './pages/EBrary/Journal_Details';
import Journal_Article_Details from './pages/EBrary/Journal_Article_Details';

const AppRoutes = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  const hasCollege = user && user.collegeId;
  const isLibrarian = user?.role === "Librarian";

    // 🚫 Redirect to login if user is not authenticated
    if (!user) {
      return <Navigate to="/LoginPage" replace />;
    }

  return (

      <Routes>
        <Route path="/" element={<SidebarLayout />}>
          <Route path="mycourse" element={<MyCourse />} />
          <Route path="/course/:courseId" element={<AccessCourse />} />
          {/* ✅ Conditionally render mylibrary routes */}
          {hasCollege && (
            <>
              <Route path="mylibrary" element={<MyLibrary />} />
              <Route path="mylibrary/:id" element={<ArticleDetails_Self />} />
            </>
          )}
              <Route path="ebrarycollection" element={<EbraryCollection />} />
              <Route path="ebrarycollection/:id" element={<ArticleDetails_Ebrary />} />
              <Route path="ejournals" element={<EJournals />} />
              <Route path="ejournals/:id" element={<JournalDetails />} />
              <Route path="journal_articles" element={<Journal_Articles />} />
              <Route path="journal_articles/:id" element={<Journal_Article_Details />} />
          <Route path="book/:id" element={<ArticleDetails_Book />} />
          <Route path="elearning/:subjectId" element={<ELearningModulePage />} />

          {isLibrarian && (
            <>
              <Route path="librarymanagement" element={<LibraryManagement />} />
              <Route path="addbook" element={<AddBookPage />} />
              <Route path="addbook1" element={<AddBookPage1 />} />
              <Route path="addbook2" element={<AddBookPage2 />} />
              <Route path="editbook/:bookId" element={<EditBookPage />} />
              <Route path="deletebook" element={<DeleteBookPage />} />
              <Route path="usermanagement" element={<UserManagement />} />
              <Route path="adduser" element={<AddUserPage />} />
              <Route path="edituser/:userId" element={<EditUserPage />} />
              <Route path="deleteuser" element={<DeleteUserPage />} />
              <Route path="usagereports" element={<UsageReports />} />
            </>
          )}
        </Route>
      </Routes>

  );
};

export default AppRoutes;
